// Name-pattern classifier, kept as a fallback for legacy documents that
// predate the schichtType field being surfaced by the analytics API.
export const classifyMaterialByName = (materialName) => {
  if (!materialName) return null;
  const name = materialName.toLowerCase();
  if (
    name.includes('deckschicht') ||
    name.match(/^ac \d+ d/) ||
    name.match(/^sma \d+$/) ||
    name.match(/^sma \d+ s/) ||
    name.match(/^sma \d+ n/) ||
    name.match(/^ma \d/)
  ) return 'Deckschicht';
  if (
    name.includes('binderschicht') ||
    name.match(/^ac \d+ b/) ||
    name.match(/^sma \d+ b/)
  ) return 'Binderschicht';
  if (
    name.includes('tragschicht') ||
    name.includes('tragdeckschicht') ||
    name.match(/^ac \d+ t/) ||
    name.match(/^atb/)
  ) return 'Tragschicht';
  if (name.match(/^(ac|sma|ma) \d+/)) return 'Deckschicht';
  return null;
};

export const getSchichtType = (material) =>
  material?.schichtType || classifyMaterialByName(material?.name);
